<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content>
  <p class="text-center text-lg">{{ questionText }}</p>
  <ng-content />
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close(false)">{{ noText }}</button>
  <button mat-raised-button color="primary" [disabled]="isDisabled" (click)="close(true)">{{ yesText }}</button>
</mat-dialog-actions>
